import { useLoginBrowserHelp } from "@app/auth/hooks/use-login-browser-help.hook";
import { Button, buttonVariants } from "@design-system/components/Button";
import { trans } from "@mongez/localization";

/**
 * Advice shown under the login/register form when this browser cannot
 * complete any secure sign-in method — with a one-tap way out.
 */
export function LoginBrowserHelp() {
  const { reason, chromeIntentUrl, secureUrl, copyPageLink, dismiss } =
    useLoginBrowserHelp();

  if (!reason) return null;

  return (
    <div
      role="alert"
      className="space-y-3 rounded-2xl border-2 border-amber-300 bg-amber-50 p-4 text-sm text-amber-950 dark:border-amber-500/60 dark:bg-amber-950/40 dark:text-amber-100"
    >
      <p className="text-base font-bold">
        {trans(`auth.browserHelp.${reason}.title`)}
      </p>
      <p className="leading-relaxed">
        {trans(`auth.browserHelp.${reason}.body`)}
      </p>

      <div className="flex flex-wrap gap-2">
        {chromeIntentUrl && (
          <a
            href={chromeIntentUrl}
            className={buttonVariants({ color: "green", size: "md" })}
          >
            {trans("auth.openInChrome")}
          </a>
        )}
        {secureUrl && (
          <a
            href={secureUrl}
            className={buttonVariants({ color: "green", size: "md" })}
          >
            {trans("auth.openSecureVersion")}
          </a>
        )}
        {(reason === "inAppBrowser" || reason === "privateMode") && (
          <Button type="button" variant="outline" size="md" onClick={copyPageLink}>
            {trans("auth.copySiteLink")}
          </Button>
        )}
        <Button type="button" variant="ghost" size="md" onClick={dismiss}>
          {trans("auth.dismissBrowserHelp")}
        </Button>
      </div>
    </div>
  );
}
